import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CalculatedFiltersListForNro = lazy(
  () => import("@segments/CalculatedFiltersList/CalculatedFiltersListForNro")
);

export const calculatedFiltersListNRO: NavigationRoutingObject = {
  Component: CalculatedFiltersListForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-sidebar-pill-menu-option", "Calculated Filters"),
  pageNameForTracking: () => "Calculated Filters",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-description-nav", "Create reusable filters from event, purchase, and eCommerce data"),
  icon: "nav-system-calculated-filters",
  tag: "beta",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("calculated_filters"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_filters/:appGroupId",
};
